export default __webpack_public_path__ + "static/media/V250MANB2.5859d171.pdf";